function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import { IlcIntl } from 'ilc-sdk/app';
import singleSpaEvents from './constants/singleSpaEvents';
import { removeQueryParams } from '../common/utils';
var _i18nConfig = /*#__PURE__*/new WeakMap();
var _supportedLang = /*#__PURE__*/new WeakMap();
var _defaultHrefLangValue = /*#__PURE__*/new WeakMap();
var _logger = /*#__PURE__*/new WeakMap();
var _handleRoutingChange = /*#__PURE__*/new WeakMap();
export var HrefLangHandler = /*#__PURE__*/function () {
  function HrefLangHandler(i18nConfig, logger) {
    var _this = this,
      _i18nConfig$supported;
    _classCallCheck(this, HrefLangHandler);
    _classPrivateFieldInitSpec(this, _i18nConfig, null);
    _classPrivateFieldInitSpec(this, _supportedLang, null);
    _classPrivateFieldInitSpec(this, _defaultHrefLangValue, 'x-default');
    _classPrivateFieldInitSpec(this, _logger, null);
    _classPrivateFieldInitSpec(this, _handleRoutingChange, function (event) {
      var url = removeQueryParams(event.target.location.href);
      var hrefLinks = document.querySelectorAll('link[rel="alternate"][data-ilc="1"][hreflang]');
      hrefLinks.forEach(function (linkTag) {
        try {
          var lang = linkTag.getAttribute('hreflang');
          var localizedUrl = null;
          if (lang === _classPrivateFieldGet(_defaultHrefLangValue, _this)) {
            localizedUrl = IlcIntl.localizeUrl(_classPrivateFieldGet(_i18nConfig, _this), url, {
              locale: _classPrivateFieldGet(_i18nConfig, _this)["default"].locale
            });
          } else {
            localizedUrl = IlcIntl.localizeUrl(_classPrivateFieldGet(_i18nConfig, _this), url, {
              locale: lang
            });
          }
          linkTag.setAttribute('href', localizedUrl);
        } catch (error) {
          _classPrivateFieldGet(_logger, _this).error('HrefLangHandler: Error while updating hreflang links', error);
        }
      });
    });
    _classPrivateFieldSet(_supportedLang, this, (i18nConfig === null || i18nConfig === void 0 || (_i18nConfig$supported = i18nConfig.supported) === null || _i18nConfig$supported === void 0 ? void 0 : _i18nConfig$supported.locale) || []);
    _classPrivateFieldSet(_i18nConfig, this, i18nConfig);
    _classPrivateFieldSet(_logger, this, logger);
  }
  return _createClass(HrefLangHandler, [{
    key: "start",
    value: function start() {
      window.addEventListener(singleSpaEvents.ROUTING_EVENT, _classPrivateFieldGet(_handleRoutingChange, this));
    }
  }, {
    key: "stop",
    value: function stop() {
      window.removeEventListener(singleSpaEvents.ROUTING_EVENT, _classPrivateFieldGet(_handleRoutingChange, this));
    }
  }]);
}();